import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Flex } from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import DeliveryFrequencyModalEN from 'components/GlobalModals/DeliveryFrequencyModal/locales/DeliveryFrequencyModal_en_US';
import DeliveryFrequencyModalFR from 'components/GlobalModals/DeliveryFrequencyModal/locales/DeliveryFrequencyModal_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(DeliveryFrequencyModalEN, DeliveryFrequencyModalFR);

function DeliveryFrequencyCTA(props) {
    return (
        <Flex marginTop={3}>
            <Button
                onClick={props.onDismiss}
                marginRight={2}
                width='50%'
                variant='secondary'
            >
                {getText('cancel')}
            </Button>
            <Button
                onClick={props.onSave}
                width='50%'
                variant='primary'
            >
                {getText('save')}
            </Button>
        </Flex>
    );
}

export default wrapFunctionalComponent(DeliveryFrequencyCTA, 'DeliveryFrequencyCTA');
